export const generateRandomPassword = (): string => {
  const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const specialCharacters = '!@#$%^&*_+=';
  const allCharacters =
    'abcdefghijklmnopqrstuvwxyz' + uppercaseLetters + specialCharacters;

  let password = '';
  let hasUppercase = false;
  let hasSpecialChar = false;

  while (password.length < 9 || !hasUppercase || !hasSpecialChar) {
    const randomIndex = Math.floor(Math.random() * allCharacters.length);
    const randomChar = allCharacters[randomIndex];
    if (!hasUppercase && uppercaseLetters.includes(randomChar)) {
      hasUppercase = true;
    }
    if (!hasSpecialChar && specialCharacters.includes(randomChar)) {
      hasSpecialChar = true;
    }

    password += randomChar;
  }
  return password;
};
